import { render } from "./EditDataset.vue?vue&type=template&id=8abb80d0"
import script from "./EditDataset.vue?vue&type=script&lang=js"
export * from "./EditDataset.vue?vue&type=script&lang=js"

import "./EditDataset.vue?vue&type=style&index=0&id=8abb80d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__